import React from 'react'

import { FormsElementTypeEnum, ProcurementTypeItemFragment } from 'generated/resources/graphql'

import { Form, FormEditor } from 'modules/forms'

const PERMITTED_FIELD_TYPES: FormsElementTypeEnum[] = [
  'longtext',
  'multiselect',
  'number',
  'section',
  'select',
  'text',
  'url',
  'dropdownsingle',
  'date',
]

interface Props {
  requestType: ProcurementTypeItemFragment
  form?: Form
  setForm: (form: Form) => void
}

const FormTab = ({ form, setForm }: Props) => {
  if (!form) {
    return null
  }
  return (
    <FormEditor
      form={form}
      setForm={setForm}
      permittedFieldTypes={PERMITTED_FIELD_TYPES}
      showElementName={false}
      titleSize="small"
    />
  )
}

export default FormTab
